module.exports = "/_next/static/images/game-3-menu-slide-1-ed3219b1afdfe966ee4e395ceead7d56.png";